import IconFont from './IconFont.vue'
IconFont.install = function (Vue) {
  Vue.component('IconFont', IconFont)
}
export {
  IconFont
}
